<template>
  <div class="cart-checkout">
    <p class="cart-title">{{ Translator('front.cart.infos.title') }}</p>
    <p class="cart-title">{{ Translator('front.cart.infos.shipping_address') }}</p>
    <div class="form-display form-display--placeholder">
      <form class="std-form" @submit="onSubmitUser" ref="formUser">
        <div class="form-row is-placeholder">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.firstName }">
            <div class="form-label-container">
              <label for="firstName" class="control-label required">{{
              Translator('front.cart.infos.firstName')}}</label>
            </div>
            <input type="text" id="firstName" class="form-control" v-model="formUser.firstName" @focus="onFocus"
              @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.lastName }">
            <div class="form-label-container">
              <label for="lastName" class="control-label required">{{ Translator('front.cart.infos.lastName')}}</label>
            </div>
            <input type="text" id="lastName" class="form-control" v-model="formUser.lastName" @focus="onFocus"
              @blur="onBlur" required>
          </div>
        </div>
        <div class="form-row is-placeholder">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.shippingAddress.houseNumber }">
            <div class="form-label-container">
              <label for="shippingAddress.houseNumber" class="control-label required">{{
              Translator('front.cart.infos.houseNumber')}}</label>
            </div>
            <input type="text" id="shippingAddress.houseNumber" class="form-control" v-model="formUser.shippingAddress.houseNumber"
              @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.shippingAddress.street }">
            <div class="form-label-container">
              <label for="shippingAddress.street" class="control-label required">{{
              Translator('front.cart.infos.street')}}</label>
            </div>
            <input type="text" id="shippingAddress.street" class="form-control" v-model="formUser.shippingAddress.street"
              @focus="onFocus" @blur="onBlur" required>
          </div>
        </div>
        <div class="form-row is-placeholder">
          <div class="form-group form-group--is-placeholder"
            :class="{'is-not-empty': formUser.shippingAddress.complement }">
            <div class="form-label-container">
              <label for="shippingAddress.complement" class="control-label">{{
              Translator('front.cart.infos.complement')}}</label>
            </div>
            <input type="text" id="shippingAddress.complement" class="form-control"
              v-model="formUser.shippingAddress.complement" @focus="onFocus" @blur="onBlur">
          </div>
        </div>
        <div class="form-row is-placeholder">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.shippingAddress.postcode }">
            <div class="form-label-container">
              <label for="shippingAddress.postcode" class="control-label required">{{
              Translator('front.cart.infos.postcode')}}</label>
            </div>
            <input type="text" id="shippingAddress.postcode" class="form-control"
              v-model="formUser.shippingAddress.postcode" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.shippingAddress.city }">
            <div class="form-label-container">
              <label for="shippingAddress.city" class="control-label required">{{
              Translator('front.cart.infos.city')}}</label>
            </div>
            <input type="text" id="shippingAddress.city" class="form-control" v-model="formUser.shippingAddress.city"
              @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder"
            :class="{'is-not-empty': formUser.shippingAddress.countryCode }">
            <div class="form-label-container">
              <label for="shippingAddress.countryCode" class="control-label required">{{
              Translator('front.cart.infos.countryCode')}}</label>
            </div>
            <select id="shippingAddress.countryCode" class="form-control" v-model="formUser.shippingAddress.countryCode"
              @focus="onFocus" @blur="onBlur" @change="onChangeShippingCountry" required>
              <option :value="country.code" v-for="country in countries" :key="country.id">{{ country.name }}</option>
            </select>
          </div>
          <div class="form-group form-group--is-placeholder"
            :class="{'is-not-empty': formUser.shippingAddress.provinceCode }" v-if="provinces.shipping && provinces.shipping.length > 0">
            <div class="form-label-container">
              <label for="shippingAddress.provinceCode" class="control-label required">{{
              Translator('front.cart.infos.provinceCode')}}</label>
            </div>
            <select id="shippingAddress.provinceCode" class="form-control" v-model="formUser.shippingAddress.provinceCode"
              @focus="onFocus" @blur="onBlur" @change="onChangeShippingProvince" required>
              <option :value="province.code" v-for="province in provinces.shipping" :key="province.id">{{ province.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-row is-placeholder">
          <div class="form-group form-group--is-placeholder"
            :class="{'is-not-empty': formUser.shippingAddress.phoneNumber }">
            <div class="form-label-container">
              <label for="shippingAddress.phoneNumber" class="control-label required">{{
              Translator('front.cart.infos.phoneNumber')}}</label>
            </div>
            <input type="text" id="shippingAddress.phoneNumber" class="form-control"
              v-model="formUser.shippingAddress.phoneNumber" @focus="onFocus" @blur="onBlur" required  pattern="^\+?[0-9]{0,3}[\s.\-]?\(?[0-9]{3}\)?[\s.\-]?[0-9]{3}[\s.\-]?[0-9]{4,6}$">
          </div>
          <div></div>
        </div>
        <div class="checkbox form-same-address">
          <label>
            <input type="checkbox" v-model="sameAddress" @change="onChangeSameAddress">
            {{ Translator('front.cart.infos.same_address') }}
          </label>
        </div>
        <div v-if="!sameAddress" class="cart-infos-billing">
          <p class="cart-title">{{ Translator('front.cart.infos.billing_address') }}</p>
          <div class="form-row is-placeholder">
            <div class="form-group form-group--is-placeholder"
              :class="{'is-not-empty': formUser.billingAddress.firstName }">
              <div class="form-label-container">
                <label for="billingAddress.firstName" class="control-label required">{{
                Translator('front.cart.infos.firstName')}}</label>
              </div>
              <input type="text" id="billingAddress.firstName" class="form-control"
                v-model="formUser.billingAddress.firstName" @focus="onFocus" @blur="onBlur" required>
            </div>
            <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.billingAddress.lastName }">
              <div class="form-label-container">
                <label for="billingAddress.lastName" class="control-label required">{{
                Translator('front.cart.infos.lastName')}}</label>
              </div>
              <input type="text" id="billingAddress.lastName" class="form-control"
                v-model="formUser.billingAddress.lastName" @focus="onFocus" @blur="onBlur" required>
            </div>
          </div>

          <div class="form-row is-placeholder">
            <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.billingAddress.houseNumber }">
              <div class="form-label-container">
                <label for="billingAddress.houseNumber" class="control-label required">{{
                Translator('front.cart.infos.houseNumber')}}</label>
              </div>
              <input type="text" id="billingAddress.houseNumber" class="form-control" v-model="formUser.billingAddress.houseNumber"
                @focus="onFocus" @blur="onBlur" required>
            </div>
            <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.billingAddress.street }">
              <div class="form-label-container">
                <label for="billingAddress.street" class="control-label required">{{
                Translator('front.cart.infos.street')}}</label>
              </div>
              <input type="text" id="billingAddress.street" class="form-control" v-model="formUser.billingAddress.street"
                @focus="onFocus" @blur="onBlur" required>
            </div>
          </div>
          <div class="form-group form-group--is-placeholder"
            :class="{'is-not-empty': formUser.billingAddress.complement }">
            <div class="form-label-container">
              <label for="billingAddress.complement" class="control-label">{{
              Translator('front.cart.infos.complement')}}</label>
            </div>
            <input type="text" id="billingAddress.complement" class="form-control"
              v-model="formUser.billingAddress.complement" @focus="onFocus" @blur="onBlur">
          </div>
          <div class="form-row is-placeholder">
            <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.billingAddress.postcode }">
              <div class="form-label-container">
                <label for="billingAddress.postcode" class="control-label required">{{
                Translator('front.cart.infos.postcode')}}</label>
              </div>
              <input type="text" id="billingAddress.postcode" class="form-control"
                v-model="formUser.billingAddress.postcode" @focus="onFocus" @blur="onBlur" required>
            </div>
            <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': formUser.billingAddress.city }">
              <div class="form-label-container">
                <label for="billingAddress.city" class="control-label required">{{
                Translator('front.cart.infos.city')}}</label>
              </div>
              <input type="text" id="billingAddress.city" class="form-control" v-model="formUser.billingAddress.city"
                @focus="onFocus" @blur="onBlur" required>
            </div>
            <div class="form-group form-group--is-placeholder"
              :class="{'is-not-empty': formUser.billingAddress.countryCode }">
              <div class="form-label-container">
                <label for="billingAddress.countryCode" class="control-label required">{{
                Translator('front.cart.infos.countryCode')}}</label>
              </div>
              <select id="billingAddress.countryCode" class="form-control" v-model="formUser.billingAddress.countryCode"
                @focus="onFocus" @blur="onBlur" @change="onChangeBillingCountry" required>
                <option :value="country.code" v-for="country in countries" :key="country.id">{{ country.name }}</option>
              </select>
            </div>
            <div class="form-group form-group--is-placeholder"
              :class="{'is-not-empty': formUser.billingAddress.provinceCode }" v-if="provinces.billing && provinces.billing.length > 0">
              <div class="form-label-container">
                <label for="billingAddress.provinceCode" class="control-label required">{{
                Translator('front.cart.infos.provinceCode')}}</label>
              </div>
              <select id="billingAddress.provinceCode" class="form-control" v-model="formUser.billingAddress.provinceCode"
                @focus="onFocus" @blur="onBlur" required>
                <option :value="province.code" v-for="province in provinces.billing" :key="province.id">{{ province.name }}</option>
              </select>
            </div>
          </div>

          <div class="form-row is-placeholder">
            <div class="form-group form-group--is-placeholder"
              :class="{'is-not-empty': formUser.billingAddress.phoneNumber }">
              <div class="form-label-container">
                <label for="billingAddress.phoneNumber" class="control-label required">{{
                Translator('front.cart.infos.phoneNumber')}}</label>
              </div>
              <input type="text" id="billingAddress.phoneNumber" class="form-control"
                v-model="formUser.billingAddress.phoneNumber" @focus="onFocus" @blur="onBlur" required  pattern="^\+?[0-9]{0,3}[\s.\-]?\(?[0-9]{3}\)?[\s.\-]?[0-9]{3}[\s.\-]?[0-9]{4,6}$">
            </div>
            <div></div>
          </div>
        </div>
        <button type="button" class="form-button" :class="{'is-loading': isLoadingStep}" @click="onValidStep()" v-if="step === 1">{{ Translator('front.cart.valid_step0') }}</button>
      </form>
    </div>

    <template v-if="step >= 2 && order">
      <p class="cart-title">{{ Translator('front.cart.delivery.title') }}</p>
      <div class="form-display form-display--placeholder">
        <div class="cart-loader" v-if="!isInit || methods === null"></div>
        <form class="std-form" @submit="onSubmitDelivery" ref="formDelivery" v-if="isInit && methods">
          <p class="cart-error" v-if="methods.length === 0">{{ Translator('front.cart.delivery.no_methods') }}</p>
          <div v-else>
            <div class="radio" v-for="method in methods" :key="method.id">
              <label>
                <input type="radio" v-model="formDelivery.delivery" :value="method['@id']" @change="onSubmitDelivery">
                {{ method.name }}
                <span>
                  {{ (method.price * config.currency.rate / 100) | toFixed(2) }} {{ config.currency.symbol }}
                </span>
              </label>
            </div>
          </div>
          <button type="button" class="form-button" :class="{'is-loading': isLoadingStep}" @click="onValidStep()" v-if="step === 2" :disabled="methods.length === 0">{{ Translator('front.cart.valid_step1') }}</button>
        </form>
      </div>
    </template>
    <template v-if="step >= 3 && order">
      <p class="cart-title">{{ Translator('front.cart.payment.title') }}</p>
      <div class="form-display form-display--placeholder">
        <div class="cart-loader" v-if="!isInit"></div>
        <form class="std-form" @submit="onSubmitPayment" ref="formPayment" v-if="isInit && order.totalTtc > 0">
          <div class="cart-loader" v-if="paymentMethods === null"></div>
          <div v-else>
            <div v-for="method in paymentMethods" :key="method.id">
              <div class="radio">
                <label>
                  <input type="radio" v-model="formPayment.method" :value="method['@id']" :disabled="isLoadingPayment">
                  {{ method.name }}
                </label>
              </div>
            </div>
          </div>
        </form>
        <div class="cart-free" v-if="order.totalTtc === 0">
          <p class="cart-description" v-html="Translator('front.cart.payment.free')"></p>
        </div>
      </div>
      <button type="button" @click="onGoCheckout" v-if="order && formPayment.method" class="cart-button" :class="{'is-loading': isLoadingPayment}">
        <span>{{ Translator('front.cart.checkout.button') }}</span>
      </button>
    </template>
  </div>
</template>
<script>
import AppControlService from '@/services/AppControl';
import UsersService from '@/services/Users';
import { FormControl } from 'aw-front-helpers';
import OrdersService from '@/services/Orders';
import CardService from '@/services/Card';

export default {
  name: 'cart-checkout',
  components: {
  },
  data () {
    return {
      config: window.config,
      countries: UsersService.countries,
      step: AppControlService.currentStep,
      isInit: false,
      isLoadingStep: false,
      isLoadingDelivery: false,
      isLoadingUser: false,
      isLoadingPayment: false,
      sameAddress: true,
      order: OrdersService.cart,
      methods: null,
      paymentMethods: null,
      provinces: {
        billing: null,
        shipping: null
      },
      formPayment: {
        method: null
      },
      formDelivery: {
        delivery: null,
      },
      formUser: {
        firstName: null,
        lastName: null,
        shippingAddress: {
          firstName: null,
          lastName: null,
          phoneNumber: null,

          houseNumber: null,
          street: null,
          complement: null,
          city: null,
          postcode: null,
          countryCode: null,
          provinceCode: null
        },
        billingAddress: {
          firstName: null,
          lastName: null,
          phoneNumber: null,

          houseNumber: null,
          street: null,
          complement: null,
          city: null,
          postcode: null,
          countryCode: null,
          provinceCode: null
        }
      }
    }
  },
  created() {
    this._onUpdateUser = this._onUpdateUser.bind(this);
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onUpdateCountries = this._onUpdateCountries.bind(this);
    this._onCheckError = this._onCheckError.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    UsersService.on('updated', this._onUpdateUser);
    UsersService.on('countries', this._onUpdateCountries);
    OrdersService.on('updated', this._onUpdateCart);
    AppControlService.on('validating', this._onSubmit);
  },

  beforeDestroy() {
    UsersService.off('updated', this._onUpdateUser);
    UsersService.off('countries', this._onUpdateCountries);
    OrdersService.off('updated', this._onUpdateCart);
    AppControlService.off('validating', this._onSubmit);
  },

  mounted() {
    this._onUpdateCountries();
    this._onUpdateUser();
    this._onUpdateCart();
    this._getProvinces('shipping');
    this._getProvinces('billing');
  },

  methods: {
    onChangeSameAddress() {
      this._updateForm();
      if( this.step !== 0) {
        AppControlService.goTo(1);
        this.step = AppControlService.currentStep;
      }
    },

    onValidStep() {
      if(this.isLoadingStep) return;
      this.isLoadingStep = true;
      if( this.step === 1 ) {
        this.onSubmitUser().then( () => {
          this._getShippings();
          AppControlService.goToNextStep();
          this.step = AppControlService.currentStep;
        }).then(() => {
          this.isLoadingStep = false;
        })
      } else if( this.step === 2 ) {
        if(this.methods.length === 0) return;
        this.onSubmitDelivery().then( () => {
          this._getPaymentMethods();
          AppControlService.goToNextStep();
          this.step = AppControlService.currentStep;
        }).then(() => {
          this.isLoadingStep = false;
        })
      }
    },

    onGoCheckout() {
      if (!this.isLoadingPayment) AppControlService.validStep();
    },

    onChangeShippingCountry() {
      this._getProvinces('shipping');
      if( this.step !== 0) {
        AppControlService.goTo(1);
        this.step = AppControlService.currentStep;
        const userDatas = JSON.parse(JSON.stringify(this.formUser));
        if(userDatas.shippingAddress.id) {
          this.formUser.shippingAddress.provinceCode = null;
          UsersService.updateAddress(userDatas.shippingAddress.id, {
            countryCode: userDatas.shippingAddress.countryCode,
            provinceCode: null
          });
        }
      }
    },

    onChangeBillingCountry() {
      this._getProvinces('billing');
      const userDatas = JSON.parse(JSON.stringify(this.formUser));
      if( this.step !== 0 && userDatas.billingAddress.id) {
        this.formUser.billingAddress.provinceCode = null;
        UsersService.updateAddress(userDatas.billingAddress.id, {
          countryCode: userDatas.billingAddress.countryCode,
          provinceCode: null
        });
      }
    },

    onChangeShippingProvince() {
      if( this.step === 0) return;
      AppControlService.goTo(1);
      this.step = AppControlService.currentStep;
      const userDatas = JSON.parse(JSON.stringify(this.formUser));
      if(userDatas.shippingAddress.id) {
        UsersService.updateAddress(userDatas.shippingAddress.id, {
          provinceCode: userDatas.shippingAddress.provinceCode
        });
      }
    },

    _getProvinces(type) {
      this.provinces[type] = null;
      const userDatas = JSON.parse(JSON.stringify(this.formUser));
      const country = type === 'shipping' ? UsersService.getCountry(userDatas.shippingAddress.countryCode) : UsersService.getCountry(userDatas.billingAddress.countryCode);
      if(country) {
        UsersService.getProvinces(country.id).then(provinces => {
          this.provinces[type] = provinces;
          setTimeout(() => {
            this._formUser.update();
          });
        });
      }
    },

    _onSubmit() {
      if(this.isLoadingPayment) return;
      if(!this.order.shippingMethod || !this.order.shippingAddress || !this.order.cartPayment) return;
      this.isLoadingPayment = true;
      OrdersService.update({
        paymentMethod: this.formPayment.method
      }).then( () => {
        AppControlService.goToNextStep();
      }).catch( () => {
        this.isLoadingPayment = true;
      })
    },


    onSubmitPayment(pEvt) {
      if(pEvt) pEvt.preventDefault();
    },

    onSubmitDelivery(pEvt) {
      if(pEvt) pEvt.preventDefault();

      return new Promise( (resolve, reject) => {
        if(this.isLoadingDelivery) reject();
        this.isLoadingDelivery = true;
        return OrdersService.update({
          shippingMethod: this.formDelivery.delivery
        }).then( res => {
          this.isLoadingDelivery = false;
          resolve(res);
        }).catch( err => {
          this.isLoadingDelivery = false;
          reject(err);
        });
      });
    },

    _addressIsUniq( address ) {
      if(!address) return true;
      this.user.addresses.forEach( add => {
        if(add.id === address.id) return false;
      })
      return true;
    },

    onSubmitUser(pEvt) {
      if(pEvt) pEvt.preventDefault();
      return new Promise( (resolve, reject) => {
        if(this.isLoadingUser) reject();
        this.isLoadingUser = true;

        if(this._formUser.isValidate) {
          const userDatas = JSON.parse(JSON.stringify(this.formUser));
          const addresses = [];
          const shippingAddress = { ...userDatas.shippingAddress };
          shippingAddress.firstName = userDatas.firstName;
          shippingAddress.lastName = userDatas.lastName;
          if( this.order.shippingAddress && this._addressIsUniq(this.order.shippingAddress) ) {
            addresses.push( UsersService.updateAddress(this.order.shippingAddress.id, shippingAddress) );
          } else {
            shippingAddress.name ='default';
            delete shippingAddress['@id'];
            delete shippingAddress['@type'];
            delete shippingAddress.id;
            addresses.push( UsersService.addAddress(shippingAddress) );
          }

          if(!this.sameAddress) {
            const billingAddress = { ...userDatas.billingAddress };
            billingAddress.firstName = userDatas.firstName;
            billingAddress.lastName = userDatas.lastName;
            if( this.order.billingAddress && this._addressIsUniq(this.order.billingAddress) && this.order.billingAddress.id !== this.order.shippingAddress.id) {
              addresses.push( UsersService.updateAddress(this.order.billingAddress.id, billingAddress) );
            } else {
              billingAddress.name ='default';
              delete billingAddress['@id'];
              delete billingAddress['@type'];
              delete billingAddress.id;
              addresses.push( UsersService.addAddress(billingAddress) );
            }
          }

          if(this.user.addresses.length === 0) {
            addresses.push( UsersService.addAddress(shippingAddress) );
          }
          Promise.all(addresses).then( ([shipping, billing, user]) => {
            delete userDatas.email;
            delete userDatas.shippingAddress;
            delete userDatas.billingAddress;

            if(this.user.addresses.length === 0) {
              userDatas.addresses = user && user.data['@id'] ? [user.data['@id']] : [billing.data['@id']];
            }
            const seqUser = UsersService.update(UsersService.user.id, userDatas);

            const orderDatas = {};
            if (!this.order.shippingAddress) orderDatas.shippingAddress = shipping.data['@id'];
            if (!this.order.billingAddress) orderDatas.billingAddress = !this.sameAddress ? billing.data['@id'] : shipping.data['@id'];
            if (!this.sameAddress && this.order.shippingAddress && this.order.billingAddress && this.order.billingAddress.id === this.order.shippingAddress.id) {
              orderDatas.shippingAddress = shipping.data['@id'];
              orderDatas.billingAddress = billing.data['@id'];
            }
            if( this.sameAddress ) {
              orderDatas.shippingAddress = shipping.data['@id'];
              orderDatas.billingAddress = shipping.data['@id'];
            }
            const seqOrder = OrdersService.update(orderDatas);

            Promise.all([seqOrder, seqUser]).then( () => {
              this.isInit = false;
              OrdersService.get().then( () => {
                resolve();
              })
            }).catch((err) => {
              reject(err);
            }).then( () => {
              this.isLoadingUser = false;
              this.isLoadingStep = false;
            });
          }).catch( (err) => {
            this.isLoadingUser = false;
            this.isLoadingStep = false;
            reject(err);
          });
        } else {
          this.isLoadingUser = false;
          this.isLoadingStep = false;
          reject('User form not valid');
        }
      });
    },

    onFocus(pEvt) {
      pEvt.target.closest('.form-group').classList.add('is-focus');
    },

    onBlur(pEvt) {
      const el = pEvt.target;
      const group = el.closest('.form-group');
      group.classList.remove('is-focus');

      let isEmpty = true;
      if ((el.tagName === 'INPUT' || el.tagName === 'SELECT') && el.value !== '') isEmpty = false;
      else if (el.tagName === 'TEXTAREA' && el.value !== '') isEmpty = false;
      group.classList.toggle('is-not-empty', !isEmpty);
    },

    _onUpdateCountries() {
      this.countries = UsersService.countries;
    },

    _onUpdateCart() {
      if (OrdersService.cart && !this.isInit) {
        this.isInit = true;
        this.order = OrdersService.cart;
        if(this.order.shippingMethod) this.formDelivery.delivery = this.order.shippingMethod['@id'];
        if( this.order.shippingAddress ) {
          this.formUser.shippingAddress = {
            ...this.order.shippingAddress
          }
        }
        if( this.order.billingAddress ) {
          this.formUser.billingAddress = {
            ...this.order.billingAddress
          }
        }
        if( this.order.shippingAddress && this.order.billingAddress && this.order.shippingAddress.id !== this.order.billingAddress.id ) this.sameAddress = false;
      }
    },

    _onCheckError(pEvt) {
      this[`error${pEvt.elementType}`] = null;
      if (pEvt.error && pEvt.error.message) {
        this[`error${pEvt.elementType}`] = pEvt.error.message;
        AppControlService.abortStep();
      }
    },

    _onUpdateUser() {
      if(UsersService.user) {
        this.user = UsersService.user;
        this.formUser.firstName = UsersService.user.firstName;
        this.formUser.lastName = UsersService.user.lastName;
        this.formUser.email = UsersService.user.email;

        if( !this.order.shippingAddress ) {
          if (UsersService.user.addresses && UsersService.user.addresses.length > 0) {
            this.formUser.shippingAddress = {
              ...UsersService.user.addresses[0]
            };
          }
        }
      }
      this._updateForm();
    },

    _updateForm() {
      if (this._formUser) this._formUser.destroy();
      setTimeout(() => {
        if (this.$refs.formUser) {
          this._formUser = new FormControl(this.$refs.formUser, {
            selectorGroup: '.form-group'
          });
        }
      });
    },

    _getShippings() {
      if (OrdersService.cart) {
        this.methods = null;
        OrdersService.getShippings().then(res => {
          this.methods = res.data['hydra:member'];
        });
      }
    },

    _getPaymentMethods() {
      if(OrdersService.cart.totalTtc > 0) {
        CardService.getMethods().then( methods => {
          this.paymentMethods = methods;
          this.formPayment.method = OrdersService.cart.cartPayment.method['@id'];
        })
      }
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
.cart-checkout {
  padding: rem(40) rem(20);
  @include tablet {
    width: 50%;
    padding: rem(40);
  }
  .form-group {
    margin-top: rem(15);
  }
  .std-form {
    margin-bottom: rem(10);
    .radio {
      margin-top: rem(15);
      span {
        @include upper;
      }
    }
  }
  .form-display {
    margin-bottom: rem(20);
  }
  .form-same-address {
    margin-top: rem(30);
    margin-bottom: rem(30);
  }
  .form-button {
    margin-top: rem(20);
  }
  .cart-loader {
    @include loader($black, .7);
    min-height: rem(100);
  }
}
</style>
